module.exports = __webpack_public_path__ + "static/img/gold-button-up.32e3e974.png";